import React from 'react';
import '../../styles/Contact.css';
import '../../styles/Fonts.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const customMarkerIcon = new L.Icon({
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  shadowSize: [41, 41],
});

const locations = [
  {
    name: "MAIN OFFICE",
    address: "Retail C, GF, BM ONE Building Amvel Business Park Ninoy Aquino Ave San Dionisio, Parañaque",
    lat: 14.492629979061398,
    lng: 120.99370121014412,
  },
];

// Default center is now set to the main office coordinates
const defaultCenter = [14.492629979061398, 120.99370121014412]; // Office location in Parañaque

const PanToMarker = ({ center, zoomLevel }) => {
  const map = useMap();
  React.useEffect(() => {
    if (center) {
      map.flyTo(center, zoomLevel, { duration: 1.5 }); // Fly to the marker with animation and custom zoom level
    }
  }, [center, zoomLevel, map]);

  return null;
};

const Contact = () => {
  const [mapCenter, setMapCenter] = React.useState(defaultCenter); // Set default center to the office
  const [zoomLevel, setZoomLevel] = React.useState(14); // Start with a zoom level that focuses on the office

  const handleLocationClick = (lat, lng) => {
    setMapCenter([lat, lng]); // Update map center to the location coordinates
    setZoomLevel(18); // Set zoom level closer when clicked (e.g., zoom level 18)
  };

  return (
    <section id="contact" className="contact-preview-section">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">GET IN TOUCH</div>
          <h2 className="section-title">Our Location</h2>
          <p className="section-description">
            Visit our office or get in touch with our team for all your logistics needs.
          </p>
        </div>

        <div className="contact-content-wrapper">
          <div className="contact-info-panel">
            <div className="contact-info-header">
              <div className="contact-info-icon-large">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <h3 className="contact-info-title">Our Main Office</h3>
              <p className="contact-info-subtitle">Parañaque, Philippines</p>
            </div>

            <div className="contact-details-card">
              {locations.map((location, index) => (
                <div key={index} className="office-info">
                  <div className="office-name">
                    <i className="fas fa-building"></i>
                    <span>{location.name}</span>
                  </div>
                  <div className="office-address">
                    <i className="fas fa-map-marker-alt"></i>
                    <div className="address-text">
                      {location.address.split(',').map((line, i) => (
                        <React.Fragment key={i}>
                          {line.trim()}
                          {i < location.address.split(',').length - 1 && <br />}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                  <div className="contact-actions">
                    <button
                      className="btn-map-view"
                      onClick={() => handleLocationClick(location.lat, location.lng)}
                    >
                      <i className="fas fa-search-plus"></i>
                      View on Map
                    </button>
                    <a href="/contactUs" className="btn-contact-us">
                      <i className="fas fa-envelope"></i>
                      Contact Us
                    </a>
                  </div>
                </div>
              ))}

              <div className="contact-info-grid">
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <i className="fas fa-phone"></i>
                  </div>
                  <div className="contact-info-text">
                    <div className="contact-info-label">Phone</div>
                    <div className="contact-info-value">
                      <a href="tel:+6288250200" style={{ color: 'inherit', textDecoration: 'none', display: 'block' }}>
                        (02) 88250200
                      </a>
                      <a href="tel:+639177096992" style={{ color: 'inherit', textDecoration: 'none', display: 'block' }}>
                        +63 917 709 6992
                      </a>
                    </div>
                  </div>
                </div>
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div className="contact-info-text">
                    <div className="contact-info-label">Email</div>
                    <div className="contact-info-value">
                      <a href="mailto:sales@rcsphil.com" style={{ color: 'inherit', textDecoration: 'none' }}>
                        sales@rcsphil.com
                      </a>
                    </div>
                  </div>
                </div>
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <i className="fas fa-clock"></i>
                  </div>
                  <div className="contact-info-text">
                    <div className="contact-info-label">Hours</div>
                    <div className="contact-info-value">
                      Mon-Fri: 8:30 AM - 5:30 PM<br />
                      Sat: 8:30 AM - 12:30 PM
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="map-panel">
            <div className="map-container-modern">
              <MapContainer
                center={mapCenter}
                zoom={zoomLevel}
                scrollWheelZoom={false}
                touchZoom={false}
                doubleClickZoom={false}
                keyboard={false}
                zoomControl={true}
                className="modern-map"
              >
                <TileLayer
                  url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                  attribution="&copy; <a href='https://carto.com/attributions'>CARTO</a>"
                />
                {mapCenter && <PanToMarker center={mapCenter} zoomLevel={zoomLevel} />}

                {locations.map((location, index) => (
                  <Marker key={index} position={[location.lat, location.lng]} icon={customMarkerIcon}>
                    <Popup>
                      <strong>{location.name}</strong>
                      <br />
                      {location.address}
                    </Popup>
                  </Marker>
                ))}
              </MapContainer>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
